import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'

import SettingsSection from '@/components/neue/SettingsSection.vue'
import ParsleyConnectionCard from '@/components/parsley/ParsleyConnectionCard.vue'
import ConnectedAppsCard from '@/components/settings/ConnectedAppsCard.vue'
import PaytronixCard from '@/components/settings/PaytronixCard.vue'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { useSettingsForm } from '@/composables/useSettingsForm'
import { hasAiConnector } from '@/helpers/connectedApps'
import { hasParsley } from '@/helpers/parsley'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsIntegrations',
  setup(__props) {

const { user, capabilities } = useSettingsAccess()
const { values, editing } = useSettingsForm()

const hasPaytronix = computed(() => capabilities.value.includes('paytronix'))

const onPaytronixChange = (field, value) => {
  values[field] = value
  editing[field] = true
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Integrations",
        description: "Connect Bottle to the other systems you run your business on.",
        plain: ""
      }, {
        default: _withCtx(() => [
          (hasPaytronix.value)
            ? (_openBlock(), _createBlock(PaytronixCard, {
                key: 0,
                "group-id": _unref(values).paytronixGroup,
                "store-id": _unref(values).paytronixStore,
                "onUpdate:groupId": _cache[0] || (_cache[0] = value => onPaytronixChange('paytronixGroup', value)),
                "onUpdate:storeId": _cache[1] || (_cache[1] = value => onPaytronixChange('paytronixStore', value))
              }, null, 8, ["group-id", "store-id"]))
            : _createCommentVNode("", true),
          (_unref(hasParsley)(_unref(user)))
            ? (_openBlock(), _createBlock(ParsleyConnectionCard, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(hasAiConnector)(_unref(user)))
            ? (_openBlock(), _createBlock(ConnectedAppsCard, { key: 2 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}